import { mediaList } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import type { MediaItem, MediaType, NewsItem } from "@/types/media";

export function getMediaById(id: string): MediaItem | undefined {
  return mediaList.find((item) => item.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getNewsByMediaId(mediaId: string): NewsItem[] {
  return newsList.filter((item) => item.relatedMediaId === mediaId);
}

export function getMediaByType(type: MediaType | "all"): MediaItem[] {
  if (type === "all") return mediaList;
  return mediaList.filter((item) => item.type === type);
}

export function getHotMedia(count = 8): MediaItem[] {
  return [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, count);
}

export function getLatestMedia(count = 8): MediaItem[] {
  return [...mediaList].sort((a, b) => b.year - a.year).slice(0, count);
}

export function getLatestNews(count = 4): NewsItem[] {
  return [...newsList]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, count);
}

interface FilterParams {
  type?: MediaType | "all";
  region?: string;
  year?: string;
  genre?: string;
  sort?: string;
  keyword?: string;
}

export function filterMedia({
  type = "all",
  region = "全部",
  year = "全部",
  genre = "全部",
  sort = "最新",
  keyword = "",
}: FilterParams): MediaItem[] {
  let result = getMediaByType(type);

  if (region && region !== "全部") {
    result = result.filter((item) => item.region === region);
  }
  if (year && year !== "全部") {
    result = result.filter((item) => String(item.year) === year);
  }
  if (genre && genre !== "全部") {
    result = result.filter(
      (item) => item.genres.includes(genre) || item.tags.includes(genre),
    );
  }
  if (keyword.trim()) {
    const kw = keyword.trim().toLowerCase();
    result = result.filter(
      (item) =>
        item.title.toLowerCase().includes(kw) ||
        item.genres.some((g) => g.toLowerCase().includes(kw)) ||
        item.cast.some((c) => c.toLowerCase().includes(kw)) ||
        item.director.toLowerCase().includes(kw),
    );
  }

  if (sort === "最热") {
    result = [...result].sort((a, b) => b.heat - a.heat);
  } else if (sort === "评分") {
    result = [...result].sort((a, b) => b.rating - a.rating);
  } else {
    result = [...result].sort((a, b) => b.year - a.year);
  }

  return result;
}

export function getRelatedMedia(current: MediaItem, count = 6): MediaItem[] {
  const sameGenre = mediaList.filter(
    (item) =>
      item.id !== current.id &&
      (item.genres.some((g) => current.genres.includes(g)) ||
        item.region === current.region),
  );
  const pool = sameGenre.length >= count ? sameGenre : mediaList.filter(
    (item) => item.id !== current.id,
  );
  return pool.slice(0, count);
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)}万`;
  return String(heat);
}